import { scheduleKey as KEY } from '../../schemas/config';

// Types.
export const ADDED = `${KEY}/ADDED`;
export const LOAD = `${KEY}/LOAD`;
export const LOAD_FAIL = `${KEY}/LOAD_FAIL`;
export const GOAL_ADDED = `${KEY}/ADDED`;
export const EXIST = `${KEY}/EXIST`;
